import React from "react";

export const GridThemeInsideDialog = React.createContext();

export const ConsiderDefaultThemeContext = React.createContext(false);

export const IsLoggedInUsingThirdPartyProviderContext = React.createContext(false);
